import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileBottomBar from "@/components/MobileBottomBar";
import ChatWidget from "@/components/ChatWidget/ChatWidget";
import { captureAttribution } from "@/lib/attribution";

const Layout = () => {
    const { pathname } = useLocation();

    // Persist Google Ads click ids for the session. Runs on every route change
    // (it only writes when an id is actually in the URL) so an ad can land on
    // any page — not just one that happens to carry a form — and the click id
    // still reaches the submission and the call-tracking number swap.
    useEffect(() => {
        captureAttribution();
    }, [pathname]);

    // Scroll to top on route change for a cleaner page-shell experience.
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname]);

    // Hide the chat widget on the private admin surface.
    const showChat = !pathname.startsWith("/admin");

    return (
        <div className="flex min-h-screen flex-col bg-brand-white" data-testid="site-layout">
            <Header />
            <main className="flex-1 pb-16 md:pb-0" data-testid="site-main">
                <Outlet />
            </main>
            <Footer />
            <MobileBottomBar />
            {showChat && <ChatWidget />}
        </div>
    );
};

export default Layout;
